const routes = {
  Login: "/Login",
  SearchUser: "/Searchuser",
  UserDetails: "/userdetails/:type",
  CallLogs: "/call-logs/:id",
  CancelledOrders: "/CancelledOrders",
  upload: "/upload",
  history: "/history",
  orderModification: "/orderModification"
};
export default routes;
